var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-styles rich-text-widget",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.widget.object.userText)}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }